"use strict";

exports.__esModule = true;
exports.PanelType = exports.PanelSizeWidth = exports.PanelContentType = exports.ActionType = exports.ActionName = void 0;
// COPIED FROM @wix/ambassador-devcenter-v1-component-type-data/types to decrease pakcage bundle size
/** Represents the information needed for code panels */
let PanelSizeWidth = exports.PanelSizeWidth = /*#__PURE__*/function (PanelSizeWidth) {
  PanelSizeWidth["UNKNOWN_WIDTH"] = "UNKNOWN_WIDTH";
  PanelSizeWidth["SMALL"] = "SMALL";
  PanelSizeWidth["MEDIUM"] = "MEDIUM";
  PanelSizeWidth["LARGE"] = "LARGE";
  return PanelSizeWidth;
}({});
let PanelContentType = exports.PanelContentType = /*#__PURE__*/function (PanelContentType) {
  PanelContentType["UNKNOWN_PanelContentType"] = "UNKNOWN_PanelContentType";
  PanelContentType["url"] = "url";
  PanelContentType["code"] = "code";
  return PanelContentType;
}({});
let PanelType = exports.PanelType = /*#__PURE__*/function (PanelType) {
  PanelType["UNKNOWN_PanelType"] = "UNKNOWN_PanelType";
  PanelType["panelId"] = "panelId";
  PanelType["inline"] = "inline";
  return PanelType;
}({});
let ActionName = exports.ActionName = /*#__PURE__*/function (ActionName) {
  ActionName["UNKNOWN_ActionName"] = "UNKNOWN_ActionName";
  /** Manage the component settings, this usually aligns with component data */
  ActionName["settings"] = "settings";
  /** Manage the `style` information */
  ActionName["design"] = "design";
  /** Manage any media type `data` defined in the component */
  ActionName["media"] = "media";
  /** Manage items in the component data */
  ActionName["manageItems"] = "manageItems";
  /** Open the apps default dashboard page, or select one if there is more than one */
  ActionName["dashboard"] = "dashboard";
  /** actionName to be triggered from the defined custom actions */
  ActionName["custom"] = "custom";
  return ActionName;
}({});
/** Represents an action that targets another element within the component */
let ActionType = exports.ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["UNKNOWN_ActionType"] = "UNKNOWN_ActionType";
  ActionType["data"] = "data";
  ActionType["event"] = "event";
  ActionType["panel"] = "panel";
  ActionType["forward"] = "forward";
  ActionType["style"] = "style";
  return ActionType;
}({});
//# sourceMappingURL=apiActionTypes.js.map